import {Dialog, DialogProps} from "@mui/material";

export function Dialog2(props: DialogProps & { onEnterPress?: () => void }) {
    const { onEnterPress, ...otherProps } = props;

    return (
        <Dialog {...otherProps} onKeyDown={(e) => {
            otherProps.onKeyDown?.(e);
            if(e.key !== "Enter") return;
            if(isFormElement(e.target)) return;
            onEnterPress?.();
        }} />
    )
}

function isFormElement(target: EventTarget | null): boolean {
    if(!(target instanceof HTMLElement)) return false;
    const tag = target.tagName;
    if(tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
    if(target.isContentEditable) return true;
    return false;
}